module.exports = __webpack_public_path__ + "res-static/img/icon-pin-inverted.791b28b5.svg";